import { SearchQuery } from "shared/data/reducers/types/storage";
import { isPenaltyActive } from "shared/lib/hotels/cancellationPolicy";
import { HotelOfferDetail } from "shared/types/hotels";

const filterRefundableOnlyHotel = (searchQuery: SearchQuery) => (
  hotelOffer: HotelOfferDetail
): boolean => {
  const { refundableOnly } = searchQuery;

  if (!refundableOnly) {
    return true;
  }

  const toDateStr = hotelOffer.RoomCategoriesInfo.CancellationDateRange?.ToDate;

  if (!toDateStr) {
    return false;
  }

  // Non-refundable if the penalty date is today or earlier.
  const isNonRefundable = isPenaltyActive(toDateStr);

  return !isNonRefundable;
};

export default filterRefundableOnlyHotel;
